import { render, staticRenderFns } from "./trading.vue?vue&type=template&id=2f9ad4f1&scoped=true"
import script from "./trading.vue?vue&type=script&lang=js"
export * from "./trading.vue?vue&type=script&lang=js"
import style0 from "./trading.vue?vue&type=style&index=0&id=2f9ad4f1&lang=scss"
import style1 from "./trading.vue?vue&type=style&index=1&id=2f9ad4f1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9ad4f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod-gz-clzjn-management-platform-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f9ad4f1')) {
      api.createRecord('2f9ad4f1', component.options)
    } else {
      api.reload('2f9ad4f1', component.options)
    }
    module.hot.accept("./trading.vue?vue&type=template&id=2f9ad4f1&scoped=true", function () {
      api.rerender('2f9ad4f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/module/marketplane/components/trading.vue"
export default component.exports